/**
 * KAN-744: менеджер заказа (e-commerce). При оформлении заказ получает
 * менеджера клиента; здесь его можно поменять вручную. Менять может владелец
 * или автор заказа (остальным backend отвечает 403): им селект только для
 * чтения. Выбор сохраняется сразу ("Не назначен" -> null), ошибка под селектом.
 */
import { ManagerSelect } from '@/components/managers/ManagerSelect';
import { assignErrorMessage } from '@/components/managers/assignErrorMessage';
import { useCurrentUser } from '@/hooks/useCurrentUser';
import { useAssignEstimateManager } from '@/hooks/useManagers';
import type { ManagerBrief } from '@/types/manager';

export const ORDER_MANAGER_READONLY_HINT = 'Менять менеджера заказа может владелец или автор заказа';

interface Props {
  estimateId: string;
  manager: ManagerBrief | null | undefined;
  /** Автор заказа (id пользователя). */
  createdBy?: string | null;
}

export function EstimateManagerSelect({ estimateId, manager, createdBy }: Props): JSX.Element {
  const assign = useAssignEstimateManager(estimateId);
  const { data: me } = useCurrentUser();
  const canEdit = me?.role === 'OWNER' || (!!me?.id && me.id === createdBy);
  return (
    <div
      className="flex items-start gap-3"
      data-testid="order-manager"
      title={canEdit ? undefined : ORDER_MANAGER_READONLY_HINT}
    >
      <span className="shrink-0 pt-2 text-sm text-gray-500">Менеджер</span>
      <div className="w-56 max-w-full">
        <ManagerSelect
          value={manager}
          onSelect={(id) => assign.mutate(id)}
          pending={assign.isPending}
          disabled={!canEdit}
          error={assignErrorMessage(assign.error)}
          testId="order-manager-select"
        />
      </div>
    </div>
  );
}
